import React from 'react';
import { CalculatorIcon } from 'lucide-react';
import { footerLinks } from '../data/content';
export function Footer() {
  return <footer className="w-full border-t border-surface/10 bg-inverse-strong px-5 py-14" data-id="element-93" data-mp="3gg1025qei1yp">
      <div className="mx-auto max-w-5xl text-center" data-id="element-94" data-mp="32ovvqqc38li1">
        <p className="inline-flex items-center gap-2 font-display text-xl font-black uppercase tracking-tight text-surface" data-id="element-95" data-mp="36pfsvtwnvp46">
          <CalculatorIcon className="h-5 w-5 text-highlight" aria-hidden="true" data-id="element-96" data-mp="3uesbfkdvp9j5" />
          Matematica Pronta™
        </p>
        <p className="mx-auto mt-3 max-w-md text-xs leading-relaxed text-surface/55" data-id="element-97" data-mp="37ftv4932u2p">
          Il sistema completo per docenti di matematica che vogliono smettere di
          preparare ogni lezione da zero.
        </p>
        <nav aria-label="Footer" data-id="element-98" data-mp="3qblxrrofsg2n">
          <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-xs font-semibold text-surface/65" data-id="element-99" data-mp="29zgkq0kfasm4">
            {footerLinks.map(link => <li key={link} data-id="element-100" data-mp="2ezutxlxrg8lq">
                <a href="#offerta" className="transition-colors duration-150 hover:text-highlight focus:outline-none focus-visible:text-highlight focus-visible:underline" data-id="element-101" data-mp="2evxbz3mx5n3f">
                  {link}
                </a>
              </li>)}
          </ul>
        </nav>
        <p className="mx-auto mt-7 max-w-2xl text-[11px] leading-relaxed text-surface/40" data-id="element-102" data-mp="3v9b1tiy2kafh">
          © 2026 Matematica Pronta — Tutti i diritti riservati.
        </p>
      </div>
    </footer>;
}